<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

import router, { webRoutes, mobileRoutes } from "./router/index";
// import autofit from 'autofit.js';
// autofit.init({
//   el: '#app',
//   // dw: 1920,
//   // dh: 1080,
// })

function debounce(func, delay) {
  let timer = null;
  return function () {
    const context = this;
    const args = arguments;
    // 如果定时器已经存在，就清除它
    if (timer) {
      clearTimeout(timer);
    }
    // 重新设置定时器
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
let currentDevice = null;
const resizeHandler = debounce(() => {
  const isMobile = window.innerWidth < 1160;
  console.log("isMobile", isMobile);
  if (isMobile === currentDevice) return;
  router.getRoutes().forEach((route) => router.removeRoute(route.name));
  // 添加新路由
  (isMobile ? mobileRoutes : webRoutes).forEach((route) =>
    router.addRoute(route)
  );

  currentDevice = isMobile;
  let queryStr = window.location.href.split("?")[1];
  let queryDataList;
  let obj;
  if (queryStr?.length > 0) {
    queryDataList = queryStr.split("&");
    obj = {};
    queryDataList.forEach((item) => {
      // 解决页面刷新-路由携带的参数被编码的问题
      const key = decodeURIComponent(item.split("=")[0]);
      const val = decodeURIComponent(item.split("=")[1]);
      obj[key] = val;
    });
    router.replace({
      path: router.currentRoute.value.path,
      query: obj,
    });
  } else {
    router.replace({
      path: router.currentRoute.value.path,
    });
  }
}, 1000);

let wow;
export default {
  name: "App",
  data() {
    return {
      scaleRatio: 1,
    }
  },
  components: {
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    window.addEventListener("scroll", this.scrollMoveHandle);
    // this.calculateScale();
    // window.addEventListener('resize', this.calculateScale);
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.scrollMoveHandle);

    // window.removeEventListener('resize', this.calculateScale);
  },
  methods: {
    handleResize() {
      console.log("resize====>窗口变化");
      this.$store.commit("setWindowWidth", window.innerWidth);
      resizeHandler();
    },
    scrollMoveHandle() {
      // console.log('app根组件==>scroll事件触发',document.documentElement.scrollTop);
      this.$store.commit("setScrollTop", document.documentElement.scrollTop);
    },

    calculateScale() {
      let screenWidth = window.innerWidth;
      let baseWidth = 1920;
      this.scaleRatio = Math.max(baseWidth / screenWidth, 0.3);
      // 直接操作DOM应用缩放
      document.getElementById('app').style.transform = `scale(${this.scaleRatio})`;
      this.$message.info(`缩小比例为:${this.scaleRatio}`)
    },
  },
};
</script>

<style lang="less">
/* @import "./assets/css/style-starter.css"; */
/* @import "./assets/css/define-self.css"; */
@import "./assets/css/ckeditor5-content.css";

body {
  overflow-y: scroll;

  &::-webkit-scrollbar {
    // width: 2px;
  }
}

#app {
  // width: 100%;
  // height: 100%;

  /*font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;*/
  & * {
    .hidden-scrollbar;
  }
}
</style>
